import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { PersonalProtectiveEquipmentFilterInput, PpeTotalizerChangeDto } from '../../core/interfaces/personal-protective-equipment-filter-input';
import { Subject, throwError } from 'rxjs';
import { catchError, finalize, takeUntil } from 'rxjs/operators';
import { SStatsCardPersonalProtectiveEquipmentService } from './s-stats-card-personal-protective-equipment.service';
import { PersonalProtectiveEquipmentSituationType } from '../../core/enums/personal-protective-equipment-situation-type';

@Component({
    selector: "s-stats-card-personal-protective-equipment",
    templateUrl: "./s-stats-card-personal-protective-equipment.component.html",
    styleUrls: ["./s-stats-card-personal-protective-equipment.component.scss"]
})
export class SStatsCardPersonalProtectiveEquipmentComponent implements AfterViewInit, OnDestroy {

    @Input() domain: string;
    @Input() service: string;
    @Input() ppeSituationType: PersonalProtectiveEquipmentSituationType;
    @Input() employeeSearch: string;
    @Output() totalizerChangeEvent = new EventEmitter<PpeTotalizerChangeDto>();

    totalizerCountLoading = true;
    totalizerCountError = false;

    private readonly _filter: PersonalProtectiveEquipmentFilterInput = {};
    private readonly _ngUnsubscribe = new Subject();
    private _totalizerTotalPpeCount: string | number;
    private _totalizerValidCount: string | number;
    private _totalizerExpiringSoonCount: string | number;
    private _totalizerExpiredCount: string | number;

    constructor(
        private readonly _translateService: TranslateService,
        private readonly route: ActivatedRoute,
        private readonly _sStatsCardPersonalProtectiveEquipmentService: SStatsCardPersonalProtectiveEquipmentService
    ) {
    }

    ngOnDestroy(): void {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }

    @Input()
    public set ticket(ticket) {
        this._filter.ticket = ticket;
        if (ticket && this.domain && this.service) {
            this.updateCounters();
        }
    }

    ngAfterViewInit() {
        if (!this._filter?.ticket) {
            this.updateCounters();
        }
    }

    private genericGet(value: string | number): string {
        if (typeof value === 'string') {
            return value;
        }
        return value && value >= 1 ? value.toString() : '0';
    }

    private setFields() {
        this._filter.domain = this.domain;
        this._filter.service = this.getService();
        this._filter.ppeSituationType = this.ppeSituationType;
        this._filter.employeeSearch = this.employeeSearch;
    }

    public updateCounters() {
        this.totalizerCountLoading = true;
        const messageError = this._translateService.instant('hcm.analytics_sst.error_fetching_count');
        this.setFields();
        this._sStatsCardPersonalProtectiveEquipmentService.totalizerPersonalProtectiveEquipementCardsCount(this._filter)
            .pipe(takeUntil(this._ngUnsubscribe),
                finalize(() => {
                    const totalizerChangeDto: PpeTotalizerChangeDto = {
                        totalizerTotalPpeCount: this.totalizerTotalPpeCount,
                        totalizerValidCount: this.totalizerValidCount,
                        totalizerExpiringSoonCount: this.totalizerExpiringSoonCount,
                        totalizerExpiredCount: this.totalizerExpiredCount
                    };
                    this.totalizerChangeEvent.next(totalizerChangeDto);
                })
            )
            .pipe(catchError(error => {
                this.totalizerTotalPpeCount = messageError;
                this.totalizerValidCount = messageError;
                this.totalizerExpiringSoonCount = messageError;
                this.totalizerExpiredCount = messageError;
                this.totalizerCountLoading = false;
                this.totalizerCountError = true;
                return throwError(error);
            }))
            .subscribe((data: any) => {
                this.totalizerTotalPpeCount = data.result.personalProtectiveEquipmentTotalCount;
                this.totalizerValidCount = data.result.validCount;
                this.totalizerExpiringSoonCount = data.result.toExpireCount;
                this.totalizerExpiredCount = data.result.expiredCount;
                this.totalizerCountError = false;
                this.totalizerCountLoading = false;
            });
    }

    get totalizerTotalPpeCount() {
        return this.genericGet(this._totalizerTotalPpeCount);
    }

    set totalizerTotalPpeCount(value: string | number) {
        this._totalizerTotalPpeCount = value;
    }

    get totalizerValidCount() {
        return this.genericGet(this._totalizerValidCount);
    }

    set totalizerValidCount(value: string | number) {
        this._totalizerValidCount = value;
    }

    get totalizerExpiringSoonCount() {
        return this.genericGet(this._totalizerExpiringSoonCount);
    }

    set totalizerExpiringSoonCount(value: string | number) {
        this._totalizerExpiringSoonCount = value;
    }

    get totalizerExpiredCount() {
        return this.genericGet(this._totalizerExpiredCount);
    }

    set totalizerExpiredCount(value: string | number) {
        this._totalizerExpiredCount = value;
    }

    /**
     * Esse funÃ§Ã£o foi criada pra chavear o contexto do filtro avanÃ§ado.
     * Quando vier do analytics-frontend, deve passar o serviÃ§o analytics, quando abrir direto na tela
     * do analytics-sst, deve passar o serviÃ§o do analytics_sst
     * o parametro "ticket" sÃ³ vai vir na rota, atrÃ¡ves do analytics-frontend
     * @private
     */
    private getService() {
        let service = this.service;
        if (this.route?.snapshot?.queryParams["ticket"]) {
            service = "analytics";
        }
        return service;
    }
}
